import type { QueryClient } from '@tanstack/react-query';
import { notFound } from '@tanstack/react-router';

import type { LocationId } from '@brightlocal/shared';

import { classifyLocationError } from './classifyLocationError';
import { LOCATION_ERROR_TYPES } from '../consts';
import { locationQuery } from '../locationQuery';

interface EnsureLocationParams {
  /** Router-context query client the `$id` loader runs with. */
  queryClient: QueryClient;
  /** Numeric location id from the route params. */
  locationId: LocationId;
}

/**
 * Loads the location for the `$id` route. A 404 from the API becomes a router `notFound()`, so
 * the not-found page renders instead of the error component; every other failure is rethrown
 * for the route's `errorComponent` to map.
 */
export const ensureLocation = async ({ queryClient, locationId }: EnsureLocationParams) => {
  try {
    return await queryClient.ensureQueryData(locationQuery(locationId));
  } catch (error) {
    if (classifyLocationError(error) === LOCATION_ERROR_TYPES.NOT_FOUND) {
      throw notFound();
    }

    throw error;
  }
};
